export const bioData = [
	{
		id: 1,
		para: "I'm a passionate technologist with a specialization in Cloud and DevOps. Currently, I’m working as an Automation Intern at Michigan Health Information Network, where I focus on optimizing their test efficiency and maintaining their cloud infrastructure (IaC).",
	},
	{
		id: 2,
		para: "As an AWS Certified Solutions Architect, I bring expertise in designing and managing scalable, secure, and cost-effective cloud environments. My professional journey includes working in startups and SaaS environments, which has honed my ability to adapt to dynamic challenges while driving impactful solutions.",
	},
	{
		id: 3,
		para: "I recently completed my Master's in Information Systems from the University of Cincinnati, along with a graduate certification in Data Analytics. Outside academics, my passion for sports led to active involvement with the UC Athletics department, where I contributed to the university's vibrant athletic community.",
	},
	{
		id: 4,
		para: "Beyond my professional interests, I enjoy spending time in nature through gardening and capturing life's fleeting moments on my street photography blog. Feel free to explore my creative work at <a href='https://www.pexels.com/@city-and-soul-snaps-2148048475/' target='_blank' class='text-blue-500 underline font-semibold'>City and Soul Snaps 📸</a>.",
	},
];
